import styled from "styled-components";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const ENTITY_IMAGE_SIZE = "48";
export const RATING_ICON_SIZE = "20";

export const VoucherEntityCardSectionWrapper = styled.div(({ theme }) => ({
    margin: `0 ${theme.spacing.medium} ${theme.spacing.xLarge}`,
}));

export const VoucherEntityCardWrapper = styled.button(({ theme }) => ({
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.xSmall,
    padding: theme.spacing.xSmall,
    border: "none",
    borderRadius: theme.cornerRadius.small,
    background: theme.colors[theme.colorMode].background_Primary,
    boxShadow: theme.elevation[theme.colorMode].skim.boxShadow,
    textAlign: "left",
}));

export const EntityImage = styled(Image)(({ theme }) => ({
    borderRadius: theme.cornerRadius.xSmall,
    objectFit: "cover",
    flexShrink: 0,
}));

export const EntityTextWrapper = styled.div({
    flex: 1,
    minWidth: 0,
});

export const EntityMetaWrapper = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.xxSmall,
    marginTop: theme.spacing.xxxSmall,
    minWidth: 0,
}));

export const RatingWrapper = styled.span(({ theme }) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing.xxxSmall,
    flexShrink: 0,
}));

export const EntitySubtitle = styled(Text)({
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
});

export const EntityMetaSeparator = styled.span({
    display: "inline-flex",
    flexShrink: 0,
    lineHeight: 0,
});

export const EntityChevronWrapper = styled.span({
    display: "inline-flex",
    flexShrink: 0,
    lineHeight: 0,
});
